import { toTimeStamp } from '@/util/util'
import moment from 'moment'
import log from 'loglevel'
import _ from 'underscore'
// filters API
import analyticsAPI from '@/api/analytics'
// import _ from 'underscore'

// single function to handle filter request payload
const handleFilterPayloadGen = (filterId, filterKey, pagination, selectedFilters, state) => {
  // prepare request payload
  let payload = {}
  payload.key = `${selectedFilters.dashboardId}_${filterKey}`
  payload.filters = { ...selectedFilters.filters }
  if (pagination) {
    payload.pagination = pagination
  }
  // send empty value of self filter
  payload.filters[filterId] = []
  _.each(payload.filters, (filter, key) => {
    if (!_.isArray(filter)) {
      let tmp = []
      if (_.isObject(filter)) {
        if (filter.value !== -1) {
          tmp.push(filter.value)
        }
      } else {
        // check if it's not null or undefined
        if (filter) {
          tmp.push(filter)
        }
      }
      payload.filters[key] = tmp
    } else {
      // set filter selectAll to empty array instead all values
      const selectedFilterData = _.values(filter)
      const stateFilter = state.generic.filters[key]
      if (stateFilter && stateFilter.data && stateFilter.data.length && selectedFilterData.length && stateFilter.data.length === selectedFilterData.length) {
        payload.filters[key] = []
      } else {
        // all filter values
        payload.filters[key] = _.values(filter)
      }
    }
  })

  // format times to timestamps
  payload.filters.date_time && payload.filters.date_time.length ? payload.filters.date_time = toTimeStamp(payload.filters.date_time) : payload.filters.date_time = []
  if (state.generic.dateTimeParam && state.generic.dateTimeParam !== '') {
    payload.filters[state.generic.dateTimeParam] = payload.filters.date_time
    delete payload.filters.date_time
  }

  // add language to payload
  if (state.translations.currentLanguage && state.translations.currentLanguage !== 'undefined') {
    payload.language = state.translations.currentLanguage
    payload.valueTranslations = true
  }

  return payload
}

const parseDate = (date, format) => {
  if (!date) return null
  return moment(date).format(format)
}

const getGenFilterDefaultState = () => {
  return {
    isGeneric: false,
    selectedFilters: {
      date_time: []
    },
    filters: {},
    time: {
      timePeriods: {
        disabled: false,
        data: []
      },
      dateFromPicker: moment().startOf('day').format('YYYY-MM-DD'),
      dateToPicker: moment().startOf('day').format('YYYY-MM-DD')
    }
  }
}

const state = {
  isGeneric: false,
  selectedFilters: {
    date_time: []
  },
  filters: {},
  time: {
    timePeriods: {
      disabled: false,
      data: []
    },
    dateFromPicker: moment().startOf('day').format('YYYY-MM-DD'),
    dateToPicker: moment().startOf('day').format('YYYY-MM-DD')
  },
  dateTimeParam: '',
  dateTimeComparisonParam: ''
}

const getters = {
  selectedFiltersGen: (state) => state.selectedFilters,
  filterItemGen: (state) => (id) => {
    return state.filters[id]
  },
  selectedItemGen: (state) => (id) => {
    return state.selectedFilters[id]
  },
  isGenericGen: (state) => state.isGeneric,
  customTimeNameGen: (state) => state.dateTimeParam,
  timePeriodsGen: state => state.time.timePeriods,
  dateFromPickerGen: state => state.time.dateFromPicker,
  dateToPickerGen: state => state.time.dateToPicker
}

const mutations = {
  GEN_SET_GENERIC (state, value) { state.isGeneric = value },
  GEN_SET_DATETIME_PARAM_NAME (state, value) { state.dateTimeParam = value },
  GEN_SET_DATETIME_COMPARISON_PARAM_NAME (state, value) { state.dateTimeComparisonParam = value },
  GEN_SET_TIMEPERIODS (state, value) {
    log.info('Time periods set', value)
    state.time.timePeriods.data = value
  },
  GEN_SET_DATE_FROM_PICKER (state, date) { state.time.dateFromPicker = date },
  GEN_SET_DATE_TO_PICKER (state, date) { state.time.dateToPicker = date },
  GEN_SET_INITIAL_SELECTED_FILTERS (state, value) {
    let output = {}
    let filters = {}
    value.forEach(function (v) {
      output[v.outputId] = v.default || []
      if (v.type === 'select' && !v.data) {
        v.data = []
      }
      filters[v.outputId] = v
    })
    state.selectedFilters = output
    state.filters = filters
  },
  GEN_SET_ANY_TIME_PERIOD_FILTER (state, dateTime) {
    if (!dateTime.length) {
      state.time.timePeriods.data[0].value = dateTime
    } else {
      const minTime = moment(dateTime[0].MinDate).format('YYYY-MM-DD HH:mm:ss')
      const maxTime = moment(dateTime[0].MaxDate).format('YYYY-MM-DD HH:mm:ss')
      state.time.timePeriods.data[0].value = [minTime, maxTime]
    }
  },
  GEN_SET_ITEM_FILTER (state, { key, value }) { state.filters[key].data = value },
  GEN_SET_SELECTED_FILTER_ITEM (state, { key, value }) { state.selectedFilters[key] = value },
  GEN_SET_ITEM_FILTER_STATUS (state, key, disabled) { state.filters[key].disabled = disabled },
  GEN_SET_TIME_FILTER_STATUS (state, disabled) { state.time.disabled = disabled },
  GEN_SET_SELECTED_FILTER (state, key, value) { state.selectedFilters[key] = value },
  GEN_SET_SELECTED_FILTER_DATE_TIME (state, value) { state.selectedFilters.date_time = value },
  GEN_RESET_FILTERS (state, value) {
    let output = {}
    value.forEach(function (v) {
      output[v.outputId] = v.default
      if (v.type === 'select' && !v.data) {
        v.data = v.default
      }
    })
    state.selectedFilters = output

    let defaultPeriod = _.find(state.time.timePeriods.data, (period) => {
      return period.default === true
    })
    if (defaultPeriod) {
      state.selectedFilters.date_time = [...defaultPeriod.value]
      state.time.dateFromPicker = parseDate(state.selectedFilters.date_time[0], 'YYYY-MM-DD')
      state.time.dateToPicker = parseDate(state.selectedFilters.date_time[1], 'YYYY-MM-DD')
    } else {
      state.time.dateFromPicker = moment().startOf('day').format('YYYY-MM-DD')
      state.time.dateToPicker = moment().startOf('day').format('YYYY-MM-DD')
    }
  },
  GEN_SET_FILTERS_FROM_QUERY (state, params) {
    log.info('Query params for time period', params.period)
    if (params.dateFrom && params.dateTo) {
      state.selectedFilters.date_time = [parseInt(params.dateFrom), parseInt(params.dateTo)]
    }
    if (params.period && params.period === 'all') {
      state.selectedFilters.date_time = []
    }
  },
  GEN_CLEAR_FILTERS (state) {
    Object.assign(state, getGenFilterDefaultState())
    log.info('Dashboard gen filter state cleared')
  }
}

const actions = {
  fetchDataGen ({ commit, getters, rootState }, { selected, filterId, filterKey, pagination }) {
    let preparedPayload = handleFilterPayloadGen(filterId, filterKey, pagination, selected, rootState)

    // add query param withoutCount=true to all filter requests
    let qp = '&withoutCount=true'

    return analyticsAPI.fetchData(preparedPayload, qp)
      .then(data => {
        if (data.errorCode) {
          commit('GEN_SET_ITEM_FILTER', { key: filterId, value: [] })
          commit('GEN_SET_ITEM_FILTER_STATUS', filterId, true)
          return Promise.reject(data)
        } else {
          commit('GEN_SET_ITEM_FILTER_STATUS', filterId, false)
          let values = data.result.map(item => {
            item.value = item.name
            item.translatedName = data.translations && _.has(data.translations, item.name) && data.translations[item.name] !== ''
              ? data.translations[item.name]
              : item.name
            return item
          })
          values.sort((a, b) => {
            if (a.translatedName && b.translatedName) {
              let aName = a.translatedName.toLowerCase()
              let bName = b.translatedName.toLowerCase()
              if (aName < bName) {
                return -1
              }
              if (aName > bName) {
                return 1
              }
              return 0
            }
            return 0
          })
          log.info(`-${filterId} loaded-`, values)
          commit('GEN_SET_ITEM_FILTER', { key: filterId, value: values })

          // reset selected filter if no value from response
          let selectedFilterValue = getters.selectedItemGen(filterId)
          if (Array.isArray(selectedFilterValue)) {
            let foundInValues = values.map(value => ({ ...value, is: selectedFilterValue.includes(value.name) }))
            if (foundInValues && !foundInValues.length) {
              commit('GEN_SET_SELECTED_FILTER_ITEM', { key: filterId, value: [] })
            }
          } else {
            let foundInValues = values.filter(value => value.value === selectedFilterValue)
            if (foundInValues && !foundInValues.length) {
              commit('GEN_SET_SELECTED_FILTER_ITEM', { key: filterId, value: [] })
            }
          }

          return Promise.resolve(data)
        }
      })
  },
  fetchAnyTimeGen ({ commit, getters, rootState }, { selected, filterId, filterKey }) {
    let preparedPayload = handleFilterPayloadGen(filterId, filterKey, selected, rootState)
    return analyticsAPI.fetchData(preparedPayload)
      .then(data => {
        if (data.errorCode) {
          commit('GEN_SET_ANY_TIME_PERIOD_FILTER', [])
          commit('GEN_SET_TIME_FILTER_STATUS', filterId, true)
          return Promise.reject(data)
        } else {
          commit('GEN_SET_ANY_TIME_PERIOD_FILTER', data.result)
          commit('GEN_SET_TIME_FILTER_STATUS', filterId, false)
          if (data.result[0] && data.result[0].MinDate) {
            log.info('filter time: ', 'min: ', data.result[0].MinDate, '; max: ', data.result[0].MaxDate)
          }
          return Promise.resolve(data)
        }
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
